import { SGFeaturedLink } from '../../types/featured-link'
import getImageFromEntry, { SQUARE, MASTER } from './get-image-from-entry'

export function graphqlToFeaturedLink(item: any): SGFeaturedLink {
  const { src, alt, imageType, supportingColor } = getImageFromEntry(
    item,
    SQUARE,
    MASTER
  )
  return {
    imageType: imageType ?? undefined,
    imageUrl: src ?? undefined,
    imageAlt: alt ?? undefined,
    title: item?.title || '',
    url: item?.url || '',
    shortDescription: item?.shortDescription,
    callToActionLabel: item?.callToActionLabel,
    supportingColor: supportingColor ?? undefined,
  }
}
